var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Icon',{class:`variable-icon variable-icon--${_vm.type}`,attrs:{"icon":_vm.icon,"size":_vm.iconSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }